

import south from "../images/SouthStudios_Logo_Blanco-150x50.png";
import "react-vertical-timeline-component/style.min.css";

import { IoMenu } from "react-icons/io5";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

function Nav() {
  const [isActive, setIsActive] = useState(false);
  return (
    
    <AnimatePresence initial={false}>
        <nav className="w-full px-6 z-50  fixed inset-x-0 top-2 flex justify-center items-center ">
          <div className=" w-full md:w-880 bg-navBar p-4 rounded-2xl flex items-center">
          <a
                href="https://southstudios.net" target="_blank"
                className="ml-auto text-base text-textBase font-medium hover:text-slate-100 cursor-pointer border border-textBase px-2 py-1 rounded-xl hover:border-gray-100 duration-100 ease-in"
              >
                <img src={south}  
            className="h-8"
            />
              </a>
            

            <div className="hidden md:flex items-center gap-10 ml-10 flex-1">
              <a
                href="boxes"
                className="text-base text-textBase font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
              >
                Boxes
              </a>
              <a
                href="boat"
                className="text-base text-textBase font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
              >
                Boat
              </a>
              <a
                href="burger"
                className="text-base text-textBase font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
              >
                Burger
              </a>
              <a
                href="puffer"
                className="text-base text-textBase font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
              >
                Puffer
              </a>
              <a
                href="carousel"
                className="text-base text-textBase font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
              >
                Carousel
              </a>
              <p className="text-lg text-slate-200 font-medium ml-auto px-2 py-1">Spline Examples</p>
              
            </div>

            <motion.div
              whileTap={{ scale: 0.6 }}
              className="block md:hidden  ml-auto cursor-pointer"
              onClick={() => setIsActive(!isActive)}
            >
              <IoMenu className="text-2xl text-textBase " />
            </motion.div>
            {isActive && (
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1.1 }}
                exit={{ opacity: 0, scale: 0.5 }}
                transition={{ delay: "0.1s", type: "spring" }}
                className="p-4 w-275 bg-navBar rounded-lg fixed top-24 right-16 flex flex-col items-center justify-evenly gap-6"
              >
                <a
                  href="boxes"
                  className="text-base text-textBase font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
                  onClick={() => setIsActive(false)}
                >
                  Boxes
                </a>
                <a
                  href="boat"
                  className="text-base text-textBase font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
                  onClick={() => setIsActive(false)}
                >
                  Boat
                </a>
                <a
                  href="burger"
                  className="text-base text-textBase font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
                  onClick={() => setIsActive(false)}
                >
                  Burger Time
                </a>
                <a
                  href="puffer"
                  className="text-base text-textBase font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
                  onClick={() => setIsActive(false)}
                >
                  Puffer
                </a>
                <a
                  href="carousel"
                  className="text-base text-textBase font-medium hover:text-slate-100 cursor-pointer duration-100 ease-in"
                  onClick={() => setIsActive(false)}
                >
                  Carousel
                </a>
                
                <a
                  
                  className="text-lg text-slate-200 font-medium"
                  onClick={() => setIsActive(false)}
                >
                  Spline Examples
                </a>
                
              </motion.div>
            )}
          </div>
        </nav>
        
        
        
        </AnimatePresence>
      
    
  );
}

export default Nav;
